import Vue from "vue";
import "./LoadingIcon";

Vue.component("LoadingIcon", () => import("./LoadingIcon"));
